// A failed dynamic import may reflect an outage or a removed deployment asset.
// It does not prove a newer version exists. Any other render error is re-thrown
// so the application-level ErrorBoundary reports and renders it.
export function isChunkLoadError(error: unknown): boolean {
  const err = error as { name?: unknown; message?: unknown } | null;
  const name = typeof err?.name === "string" ? err.name : "";
  const message = typeof err?.message === "string" ? err.message : "";
  return (
    name === "ChunkLoadError" ||
    /dynamically imported module|Importing a module script failed|Failed to fetch dynamically imported/i.test(
      message,
    )
  );
}
